module.exports = __webpack_public_path__ + "static/img/has_subscribe.ec0f09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/has_subscribe.png
// module id = b9tG
// module chunks = 3